import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const tableColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_accountCode,
    getColumns_invoiceID,
    getColumns_SqlAccountInvoiceNo,
    getColumns_date,
    getColumns_amount,
    getColumns_lastSentEmail,
    getColumns_documentDate,
}

function getColumns() {
    return [
        getColumns_invoiceID(),
        getColumns_SqlAccountInvoiceNo(),
        getColumns_accountCode(),
        getColumns_date(),
        getColumns_documentDate(),
        getColumns_lastSentEmail(),
        getColumns_amount(),
        getColumns_subsidiary(),
    ];
}

function getColumns_accountCode() {
    let columnClassName = "normalInvoices-tableColumn-accountCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_invoiceID() {
    let columnClassName = "normalInvoices-tableColumn-invoiceID";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Invoice ID",
        id: "invoiceID",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_SqlAccountInvoiceNo() {
    let columnClassName = "normalInvoices-tableColumn-sqlAccountInvoiceNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Reference Document No.",
        id: "sqlAccountInvoiceNo",
        accessor: "ReferenceDocumentNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
        width: 200
    }
}

function getColumns_date() {
    let columnClassName = "normalInvoices-tableColumn-issueDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Issue Date",
        // isHeaderColumnSortable: true,
        // sortValue: "issueDate"
        id: "issueDate",
        accessor: "IssueDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_amount() {
    let columnClassName = "normalInvoices-tableColumn-subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "SubTotal (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "subTotal"
        id: "subTotal",
        accessor: "SubTotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_lastSentEmail() {
    let columnClassName = "normalInvoices-tableColumn-lastSentEmail";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Sent Email",
        // isHeaderColumnSortable: true,
        // sortValue: "lastSentEmail"
        id: "lastSentEmail",
        accessor: "LastSendEmail",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_documentDate() {
    let columnClassName = "normalInvoices-tableColumn-documentDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Document Date",
        // isHeaderColumnSortable: true,
        // sortValue: "documentDate"
        id: "documentDate",
        accessor: "DocumentDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_subsidiary() {
  let columnClassName = "normalInvoices-tableColumn-subsidiary";

  return {
    headerCellClassName: columnClassName + " ",
    Header: "Subsidiary",
    id: "subsidiary",
    accessor: "Subsidiary",
    bodyCellClassName: columnClassName + " ",
    Cell: (props) => {
      let cell = func_validation.getObjectPropertyValue(props, "cell");
      let value = func_validation.getObjectPropertyValue(cell, "value");
      let value_formatted = func_validation.isStringTrimNotEmpty(value)
        ? value
        : "-";

      return <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>;
    },
  };
}
